import {
  SET_CLAIM_FORM_DATA,
  SET_CLAIM_FORM_STATUS,
  RESET_CLAIM_FORM,
  SUBMIT_CLAIM_FORM,
  SUBMIT_CLAIM_FORM_SUCCESS,
  SUBMIT_CLAIM_FORM_ERROR,
  SET_CONSULTATION_FORM_DATA,
  SET_CONSULTATION_FORM_STATUS,
  RESET_CONSULTATION_FORM,
  SUBMIT_CONSULTATION_FORM,
  SUBMIT_CONSULTATION_FORM_SUCCESS,
  SUBMIT_CONSULTATION_FORM_ERROR,
  SET_REGRET_FORM_DATA,
  SET_REGRET_FORM_STATUS,
  RESET_REGRET_FORM,
  SUBMIT_REGRET_FORM,
  SUBMIT_REGRET_FORM_SUCCESS,
  SUBMIT_REGRET_FORM_ERROR,
} from './action-types';
import ConsultasClient from '../../api/consultas';
import { transformReclamoPayload } from '../../helpers/transformReclamoPayload';

// Claims Form Actions
export const setClaimFormData = (formData) => ({
  type: SET_CLAIM_FORM_DATA,
  payload: formData,
});

export const setClaimFormStatus = (status) => ({
  type: SET_CLAIM_FORM_STATUS,
  payload: status,
});

export const resetClaimForm = () => ({
  type: RESET_CLAIM_FORM,
});

export const submitClaimForm = (formData) => {
  return async (dispatch, getState) => {
    dispatch({ type: SUBMIT_CLAIM_FORM });
    dispatch(setClaimFormStatus('sending'));

    try {
      const state = getState();
      const token = state.applicationState?.token;

      const mappedFormData = {
        agenciaId: formData.agenciaId,
        nombreAgencia: formData.nombreAgencia,
        emailAgencia: formData.emailAgencia,
        paisId: formData.paisId,
        estado: formData.estado,
        tipoDocumento: formData.tipoDocumento,
        numeroDocumento: formData.numeroDocumento,
        nombre: formData.nombre,
        apellidoPaterno: formData.apellidoPaterno,
        apellidoMaterno: formData.apellidoMaterno,
        domicilio: formData.domicilio,
        departamento: formData.departamento,
        provincia: formData.provincia,
        distrito: formData.distrito,
        telefonoFijo: formData.telefonoFijo,
        telefonoCelular: formData.telefonoCelular,
        email: formData.email,
        bienContratado: formData.bienContratado,
        monto: formData.monto,
        tipoReclamo: formData.tipoReclamo,
        detalleReclamo: formData.detalleReclamo,
        pedido: formData.pedido,
        menorEdad: formData.menorEdad,
        tipoDocumentoApoderado: formData.tipoDocumentoApoderado,
        documentoApoderado: formData.documentoApoderado,
        nombreApoderado: formData.nombreApoderado,
        apellidoPaternoApoderado: formData.apellidoPaternoApoderado,
        apellidoMaternoApoderado: formData.apellidoMaternoApoderado,
        telefonoFijoApoderado: formData.telefonoFijoApoderado,
        telefonoCelularApoderado: formData.telefonoCelularApoderado,
        emailApoderado: formData.emailApoderado,
        comentarios: formData.descripcion,
      };

      const transformedPayload = transformReclamoPayload(mappedFormData);
      const reclamoResponse = await ConsultasClient.reclamoMarcaBlanca(transformedPayload, token);
      if (!reclamoResponse || reclamoResponse.error || (reclamoResponse.response && reclamoResponse.response.status >= 400)) {
        const errorMessage = reclamoResponse?.response?.data?.message ||
          reclamoResponse?.response?.data?.error ||
          reclamoResponse?.message ||
          'Error al enviar el reclamo';
        throw new Error(errorMessage);
      }

      const emailResponse = await ConsultasClient.enviarMailReclamo(mappedFormData, token);
      if (!emailResponse || emailResponse.error || (emailResponse.response && emailResponse.response.status >= 400)) {
        const errorMessage = emailResponse?.response?.data?.message ||
          emailResponse?.response?.data?.error ||
          emailResponse?.message ||
          'Error al enviar el email de notificación';
        throw new Error(errorMessage);
      }

      dispatch({ type: SUBMIT_CLAIM_FORM_SUCCESS, payload: { reclamoResponse, emailResponse } });
      dispatch(setClaimFormStatus('success'));
    } catch (error) {
      console.error('Error en submitClaimForm:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response,
        data: error.response?.data,
        status: error.response?.status,
      });
      dispatch({ type: SUBMIT_CLAIM_FORM_ERROR, payload: error.message });
      dispatch(setClaimFormStatus('error'));
    }
  };
};

// Consultation Form Actions
export const setConsultationFormData = (formData) => ({
  type: SET_CONSULTATION_FORM_DATA,
  payload: formData,
});

export const setConsultationFormStatus = (status) => ({
  type: SET_CONSULTATION_FORM_STATUS,
  payload: status,
});

export const resetConsultationForm = () => ({
  type: RESET_CONSULTATION_FORM,
});

export const submitConsultationForm = (formData) => {
  return async (dispatch) => {
    dispatch({ type: SUBMIT_CONSULTATION_FORM });
    dispatch(setConsultationFormStatus('sending'));

    try {
      const response = await fetch('/api/consultations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        dispatch({ type: SUBMIT_CONSULTATION_FORM_SUCCESS, payload: result });
        dispatch(setConsultationFormStatus('success'));
      } else {
        throw new Error('Error en el envío del formulario');
      }
    } catch (error) {
      dispatch({ type: SUBMIT_CONSULTATION_FORM_ERROR, payload: error.message });
      dispatch(setConsultationFormStatus('error'));
    }
  };
};

// Regret Form Actions
export const setRegretFormData = (formData) => ({
  type: SET_REGRET_FORM_DATA,
  payload: formData,
});

export const setRegretFormStatus = (status) => ({
  type: SET_REGRET_FORM_STATUS,
  payload: status,
});

export const resetRegretForm = () => ({
  type: RESET_REGRET_FORM,
});

export const submitRegretForm = (formData) => {
  return async (dispatch, getState) => {
    dispatch({ type: SUBMIT_REGRET_FORM });
    dispatch(setRegretFormStatus('sending'));

    try {
      const state = getState();
      const token = state.applicationState?.token;

      // Paso 1: Enviar consulta a consultaMarcaBlanca
      const consultaResponse = await ConsultasClient.consultaMarcaBlanca(formData, token);

      if (!consultaResponse || consultaResponse.error) {
        throw new Error('Error al enviar la consulta de arrepentimiento');
      }

      // Paso 2: Enviar email de notificación a enviarMailArrepentimiento
      const emailResponse = await ConsultasClient.enviarMailArrepentimiento(formData, token);

      if (!emailResponse || emailResponse.error) {
        throw new Error('Error al enviar el email de arrepentimiento');
      }

      // Si ambas llamadas fueron exitosas
      dispatch({ type: SUBMIT_REGRET_FORM_SUCCESS, payload: { consultaResponse, emailResponse } });
      dispatch(setRegretFormStatus('success'));
    } catch (error) {
      console.error('Error en submitRegretForm:', error);
      dispatch({ type: SUBMIT_REGRET_FORM_ERROR, payload: error.message });
      dispatch(setRegretFormStatus('error'));
    }
  };
};
